
import { encryption, decryption } from '@/helpers/encryptionDecryption'
import { setToken } from '@/helpers/adminToken'
import store from '@/store'

export const loginUser = (state, { user }) => {
    state.UserLoggedIn = user
    state.status = 'authenticated'
    localStorage.setItem('authStatus','authenticated')

}

export const setUserPermissions = (state, { permissions, user, parameters, system }) => {
    state.UserLoggedIn = user
    state.permissions = permissions
    state.userParameters = parameters
    state.system = { fechaSistema: system }
    state.status = 'authenticated'
    localStorage.setItem('authStatus','authenticated')

}
export const updateShiftUser = (state, { codShift }) => {
    state.UserLoggedIn.Turno = codShift
}

export const logout = (state) => {

    state.UserLoggedIn = ''
    state.status = 'not-authenticated'
    state.permissions = []
    localStorage.removeItem('authStatus')


}
export const setInfoBackend = (state,infoBackend) => {
    state.infoBackend = infoBackend['data']['version']
}
export const setCurrentPage = (state, currentPage) => {
    state.currentPage = currentPage
}

export const showProcessHideAlert = (state,typeProcess='list') => {

    state.isLoading = true
    state.messageServer = ''
    state.showAlert = false
    state.errorsFields = {}
    state.isLoading2[typeProcess] = true

}
export const hideProcessShowAlert = (state, { messageServer, errorsFields, typeAlert, typeProcess='list' }) => {

    state.isLoading = false
    state.messageServer = messageServer
    // state.showAlert = true
    state.errorsFields = errorsFields
    state.typeAlert = typeAlert
    state.isLoading2[typeProcess] = false

}


